/**
 * @generated SignedSource<<5d6beb73d5f803c1f916679d0d7ca5ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceSettingsBodyEmployeeOnlySection_piece$data = {
  readonly id: string;
  readonly end_to_end_test_file_download_url: string | null;
  readonly " $fragmentType": "PieceSettingsBodyEmployeeOnlySection_piece";
};
export type PieceSettingsBodyEmployeeOnlySection_piece$key = {
  readonly " $data"?: PieceSettingsBodyEmployeeOnlySection_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceSettingsBodyEmployeeOnlySection_piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceSettingsBodyEmployeeOnlySection_piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end_to_end_test_file_download_url",
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "4187d84a8d3360e4bb7230a633b0c27c";

export default node;
